export default (e) => {
    console.log('listbox', e);
    return {
        initListbox() {
            console.log('init', this.open);
            this.optionCount = this.$refs.listbox.children.length;
            this.$watch("activeIndex", (e => {
                    this.open && (null !== this.activeIndex ? this.activeDescendant = this.$refs.listbox.children[this.activeIndex].id : this.activeDescendant = "")
                }
            ));
            this.$watch('open', (e) => console.log('open', e))
        },
        activeDescendant: null,
        optionCount: null,
        open: false,
        activeIndex: null,
        selectedIndex: 0,
        get active() {
            return this.items[this.activeIndex]
        },
        get [e.modelName || "selected"]() {
            return this.items[this.selectedIndex]
        },
        choose(e) {
            console.log('choose');
            this.selectedIndex = e,
                this.open = !1
        },
        onButtonClick() {
            console.log('onButtonClick');
            if (this.open) {
                return;
            }

            this.activeIndex = this.selectedIndex;
            this.open = true;
            /*this.$nextTick((() => {
                    this.$refs.listbox.focus();
                    this.$refs.listbox.children[this.activeIndex].scrollIntoView({
                        block: "nearest"
                    });
                }
            ));*/
        },
        onOptionSelect() {
            console.log('onOptionSelect');
            null !== this.activeIndex && (this.selectedIndex = this.activeIndex),
                this.open = !1,
                this.$refs.button.focus()
        },
        onEscape() {
            console.log('onEscape');
            this.open = !1,
                this.$refs.button.focus()
        },
        onArrowUp() {
            console.log('onArrowUp');
            this.activeIndex = this.activeIndex - 1 < 0 ? this.optionCount - 1 : this.activeIndex - 1,
                this.$refs.listbox.children[this.activeIndex].scrollIntoView({
                    block: "nearest"
                })
        },
        onArrowDown() {
            console.log('onArrowDown');
            this.activeIndex = this.activeIndex + 1 > this.optionCount - 1 ? 0 : this.activeIndex + 1,
                this.$refs.listbox.children[this.activeIndex].scrollIntoView({
                    block: "nearest"
                })
        },
        ...e,
    };
};
